namespace TabAurous.OMS {
    export interface ProductMoldsRow {
        ProductMoldId?: number;
        ProductId?: number;
        MoldId?: number;
        Pcs?: number;
        Code?: string;
        RackNo?: string;
    }

    export namespace ProductMoldsRow {
        export const idProperty = 'ProductMoldId';
        export const localTextPrefix = 'OMS.ProductMolds';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ProductMoldId = "ProductMoldId",
            ProductId = "ProductId",
            MoldId = "MoldId",
            Pcs = "Pcs",
            Code = "Code",
            RackNo = "RackNo"
        }
    }
}
